import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../App";
import styles from "./SimulatorHeader.styles.scss";
import TagManager from 'react-gtm-module';

const SimulatorHeader = (props) => {
    const navigate = useNavigate();
    const { step, isTotem } = useContext(UserContext);

    const navTo = (url) => {
        if (url) {
            const totemInfo = isTotem ? "totem_" : "";
            const event = {
                event: 'click',
                eventCategory: 'click',
                eventAction: totemInfo + "simulador_passo_03_click_next"
            };
    
            TagManager.dataLayer({ dataLayer: event });
            
            navigate(url);
        }
    };

    const goBack = (url = null) => {
        if (step == 1) {
            window.location.href = isTotem ? MIX_URL + "/totem" : MIX_URL;
        } else {
            navigate(url ? url : -1);
        }
    };

    if (isTotem) {
        useEffect(() => {
            const old_element = document.querySelector("a.header-back");
            const new_element = old_element.cloneNode(true);
            old_element.parentNode.replaceChild(new_element, old_element);
            const headerBack = document.querySelector("a.header-back");
            headerBack.addEventListener("click", (evt) => {
                evt.preventDefault();
                evt.stopPropagation();
                goBack();
            });
        }, [step]);
    }

    return (
        <div className="simulator-header">
            <h1 className="text-blue flex justify-center font-sans text-20 font-light h-56 mt-24 mb-32 content-center items-center">
                {props.title}
            </h1>

            <a
                onClick={() => goBack(props.prev)}
                className={`button nav-button left-button font-sans ${
                    isTotem && "hidden"
                }`}
            >
                <img src={`${MIX_URL}/front-end/img/arrow-left.svg`} /> VOLTAR
            </a>

            <a
                onClick={() => navTo(props.next)}
                className={`button nav-button blue-button right-button font-sans ${
                    props.nextHidden && "hidden"
                } ${!props.next && "disabled"}`}
            >
                <dd>
                    CONTINUAR
                    <span className="material-icons block ml-10">
                        arrow_forward
                    </span>
                </dd>

                <div className="editing-ballon">
                    Selecione um padrão para cada opção para continuar
                </div>
            </a>
        </div>
    );
};

export default SimulatorHeader;
